export class PatHistoricoBemModel {
 pesHistoricoId? :number =  0;
 patBemId? :number =  0;
 tipoMovimentacao? :number =  0;
 descricaoTipoMovimentacao? :string =  '';
 data? :Date | undefined = undefined;
 dataRetorno? :Date | undefined = undefined;
 gesEscolaId? :number =  0;
 gesSalaId? :number =  0;
 localizacao? :string =  '';
 gesFornecedorManutencaoId? :number =  0;
 observacao? :string =  '';
}
